export default "__VITE_ASSET__BFQJtHWT__"